if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute(
            "data-product-handle"
          )}"]`
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        this.updateATCText();
        this.checkUrlAndShowFastrrButton();
        this.updateMadeToOrderNote();
        this.updateBestPrice();
        this.updateInventoryIndicator();
        this.updateOutOfStockMessage();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      checkUrlAndShowFastrrButton() {
        const isPreselectVariantEnabled =
          document.querySelector(".js-add-to-cart").dataset.enabledPreselect;
        if (isPreselectVariantEnabled == "true") {
          document
            .querySelector(".shiprocket-headless.initial-button")
            ?.classList.add("hidden");
          document
            .querySelector(".shiprocket-headless.actual-button")
            ?.classList.remove("hidden");
        } else {
          if (
            window.location.href.includes("?variant=") &&
            this.currentVariant
          ) {
            document
              .querySelector(".shiprocket-headless.initial-button")
              ?.classList.add("hidden");
            document
              .querySelector(".shiprocket-headless.actual-button")
              ?.classList.remove("hidden");
          } else {
            document
              .querySelector(".shiprocket-headless.initial-button")
              ?.classList.remove("hidden");
            document
              .querySelector(".shiprocket-headless.actual-button")
              ?.classList.add("hidden");
          }
        }
      }

      updateATCText() {
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const addButton = document.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        const addButtonText = addButton?.querySelector('[name="add"] > span');
        if (addButton?.dataset.enabledPreselect == "false") {
          if (window.location.href.includes(`?variant`)) {
            if (addButton.dataset.available == "true") {
              addButtonText.textContent = window.variantStrings.addToCart;
              document.querySelector(
                ".shopify-payment-button"
              ).style.pointerEvents = "all";
            } else {
              addButtonText.textContent = window.variantStrings.soldOut;
              addButton.setAttribute("disabled", true);
              document.querySelector(
                ".shopify-payment-button"
              ).style.pointerEvents = "none";
            }
          }
        } else {
          return;
        }
      }

      onVariantChange(e) {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        this.updateBestPrice();
        this.updateInventoryIndicator();
        this.updateOutOfStockMessage();
        // Made to order
                const madeToOrderNotes = document.querySelectorAll(".made-to-order-note");
        if (madeToOrderNotes) {
          this.updateMadeToOrderNote();
        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          document
            .querySelector(".sr-headless-checkout-dummy")
            ?.setAttribute("disabled", true);
          if (window.location.href.includes("?variant=")) {
            this.setUnavailable();
          }
        } else {
          this.updateMedia();
          this.updatePrice();
          
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.updateCTAButtons(e);
          // this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      /**
       * Variant changes are handled via dedicated functions like `updatePrice`
       * and `updateCTAButtons`. For new variant-specific behavior,
       * create a separate function (e.g., `updateXYZ()`) instead of modifying these.
       *
       * The section-rendering API function renderProductInfo (re-fetching the entire section)
       * is not used. If needed in the future, comment out the update functions
       * and uncomment the API function.
       */

      updateCTAButtons(e) {
        if (window.location.href.includes("?variant=") && this.currentVariant) {
          if (this.currentVariant.available) {
            this.toggleAddButton(false, "Add To Cart");
          } else {
            this.toggleAddButton(true, "Sold Out");
          }

          // Alteration and Customization.

          const alterationButton = document.querySelector(
            ".proxy-atc-button.alteration-atc"
          );
          const customizationButton = document.querySelector(
            ".proxy-atc-button.customization-atc"
          );

          if (alterationButton) {
            alterationButton.dataset.mainProductId = this.currentVariant.id;
            alterationButton.dataset.mainProductTitle =
              this.currentVariant.title;
          }
          if (customizationButton) {
            customizationButton.dataset.mainProductId = this.currentVariant.id;
            customizationButton.dataset.mainProductTitle =
              this.currentVariant.title;
          }

          document
            .querySelector(".shiprocket-headless.initial-button")
            ?.classList.add("hidden");
          document
            .querySelector(".shiprocket-headless.actual-button")
            ?.classList.remove("hidden");
        } else {
          // quick add case
          const quickSizeInput = e.target;
          if (
            quickSizeInput.classList.contains("size-options-input") &&
            quickSizeInput.classList.contains("quick-add-enabled")
          ) {
            if (!quickSizeInput.classList.contains("disabled")) {
              this.toggleAddButton(false, "Add To Cart");
            } else {
              this.toggleAddButton(true, "Sold Out");
            }
          } else {
            this.toggleAddButton(true, "Add To Cart");
          }
        }
      }

      updateBestPrice() {
        let userTimeZone = getUserTimezone();
        const INDIA_TZS = ["Asia/Kolkata", "Asia/Calcutta"];
        const isIndia = INDIA_TZS.includes(userTimeZone);

        if (isIndia) {
          // Format number with US locale

          const formatPrice = (amount) => {
            return amount.toLocaleString("en-US");
          };
          const bestPriceContainer = document.querySelector(".offer-final");

          if (bestPriceContainer) {
            const offerDiscountPercentage =
              bestPriceContainer?.dataset?.discountAmount;

            const updatedBestPrice =
              this.currentVariant?.price -
              (this.currentVariant?.price * offerDiscountPercentage) / 100;
            if (updatedBestPrice) {
              bestPriceContainer.innerHTML = `₹ ${formatPrice(
                updatedBestPrice / 100,
              )}`;
            }
          }
        } else {
          document.querySelector(".custom-offer-block").style.display = "none";
        }
      }

      updateInventoryIndicator() {
        const variantId = this.currentVariant?.id || this.currentVariantId;
        const inventoryEl = document.querySelector(
          `#Inventory-${this.dataset.section}`,
        );

        /* the URL gains ?variant only after this runs on the first size
           click - a checked size input is just as much a selection. */
        const isVariantSelected =
          window.location.href.includes(`?variant`) ||
          !!this.querySelector("input:checked");
        if (!variantId || !inventoryEl || !isVariantSelected) return;

        const inventoryText = inventoryEl?.querySelector(".inventory-text");
        const inventoryThreshold = inventoryEl?.dataset?.inventoryThreshold;
        const inventorySVG = inventoryEl?.querySelector("svg");
        const circle = inventorySVG?.querySelectorAll(".inventory-dot");
        const showInventoryQuantity =
          inventoryEl?.dataset?.showInventoryQuantity;
        const qty = window.variantInventory?.[variantId];

        if (window.ctHideUnlessLow) {
          /* hide at zero too: continue-selling sizes would read
             "Low stock: 0 left" while still purchasable. */
          if (
            !Number.isFinite(Number(qty)) ||
            Number(qty) >= Number(inventoryThreshold) ||
            Number(qty) <= 0
          ) {
            inventoryEl.classList.add("hidden");
            return;
          }
          inventoryEl.classList.remove("hidden");
        }

        if (qty > inventoryThreshold) {
          inventoryText.textContent = showInventoryQuantity
            ? `${qty} in stock`
            : `In stock`;
          circle[0].style.fill = "rgb(62,214,96, 0.3)";
          circle[1].style.fill = "rgb(62,214,96)"; // green
        } else {
          inventoryText.textContent = showInventoryQuantity
            ? `Low stock: ${qty} left`
            : `Low stock`;
          circle[0].style.fill = "rgb(238,148,65, 0.3)";
          circle[1].style.fill = "rgb(238,148,65)"; // orange
        }
      }

      updatePrice() {
        // Format number with US locale
        const formatPrice = (amount) => {
          return amount.toLocaleString("en-US");
        };

        const compareAtPriceElement = document.querySelector(
          ".wt-product__info .wt-product__price__compare"
        );
        const sellingPriceElements = document.querySelectorAll(
          ".wt-product__info .wt-product__price__final .money"
        );
        /* main-product chip only - card chips (You May Also Like etc.) keep
           their server-rendered savings; this used to grab every chip on the
           page and hide them all when the main product had no compare-at. */
        const discountElement = document.querySelectorAll(
          ".wt-product__info .discount-percentage-wrapper"
        );
        // Compare-at price
        if (
          this.currentVariant.compare_at_price !== null &&
          compareAtPriceElement
        ) {
          const formattedComparePrice = formatPrice(
            this.currentVariant.compare_at_price / 100
          );
          compareAtPriceElement.textContent = `₹ ${formattedComparePrice}`;
        } else if (compareAtPriceElement) {
          compareAtPriceElement.textContent = "";
        }

        // Selling price
        if (
          this.currentVariant.price !== null &&
          sellingPriceElements.length > 0
        ) {
          const formattedPrice = formatPrice(this.currentVariant.price / 100);
          sellingPriceElements.forEach((element) => {
            element.textContent = `₹ ${formattedPrice}`;
          });
        }

        // Discount
        if (
          discountElement &&
          this.currentVariant.compare_at_price !== null &&
          this.currentVariant.price !== null &&
          this.currentVariant.compare_at_price > this.currentVariant.price
        ) {
          const discountAmount = Math.round(
            (this.currentVariant.compare_at_price -
              this.currentVariant.price) /
              100
          );
          const discountLabel = `Save ₹ ${discountAmount.toLocaleString(
            "en-US"
          )}`;
          discountElement.forEach((element) =>
            element.classList.remove("hidden")
          );
          discountElement.forEach(
            (element) => (element.innerHTML = discountLabel)
          );
        } else {
          discountElement.forEach((element) => element.classList.add("hidden"));
        }
      }

      
      updateOutOfStockMessage() {
        const outOfStockMessage = document.querySelector(".out-of-stock-message");
        if (!outOfStockMessage) {
          return;
        }

        const variantId = String(
          this.currentVariant?.id || this.currentVariantId || ""
        );
        const qty = parseInt(window.variantInventory?.[variantId], 10);
        let threshold = 0;

        const lowStockVariantIds =
          outOfStockMessage.dataset.oosLowStockVariantIds?.split(",") || [];
        const lowStockThreshold = parseInt(
          outOfStockMessage.dataset.oosLowStockThreshold,
          10
        );

        if (lowStockVariantIds.includes(variantId)) {
          threshold = Number.isNaN(lowStockThreshold) ? 20 : lowStockThreshold;
        }

        const variantTitle = this.currentVariant?.title?.trim()?.toUpperCase();
        const option1 = this.currentVariant?.option1?.trim()?.toUpperCase();
        const isMLSize = ["M", "L"].includes(variantTitle) || ["M", "L"].includes(option1);
        const defaultText = outOfStockMessage.dataset.oosDefaultText || "";
        const mlText = outOfStockMessage.dataset.oosMlText || "Ships in 7-10 Days";

        outOfStockMessage.textContent = isMLSize ? mlText : defaultText;

        if (qty <= threshold) {
          outOfStockMessage.classList.remove("hidden");
        } else {
          outOfStockMessage.classList.add("hidden");
        }
      }



     updateMadeToOrderNote() {
        const madeToOrderElement = document.querySelectorAll(
          ".made-to-order-note"
        );
        madeToOrderElement.forEach((element) => {
   const applicableVariants =
          element?.dataset.applicableVariantNames.split(",");
        if (applicableVariants?.includes(this.currentVariant?.title)) {
          element?.classList.remove("hidden");
        } else {
          element?.classList.add("hidden");
        }
        })
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateDropdownButtons() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option")
        );
        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            )?.value || ""
          );
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown"
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector(
              "fieldset input:checked"
            );
            if (!checkedInput) return;
            const isInputDisabled =
              checkedInput?.classList.contains("disabled");
            dropdown.classList.toggle(
              "wt-product__option__dropdown--unavailable",
              isInputDisabled
            );
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option")
        );

        this.options = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            )?.value || ""
          );
        });

        this.checkedOptions = fieldsets.map((fieldset) => {
          return (
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked
            ) || ""
          );
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.options[index];
          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value"
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span"
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`
        );
        modalContent.prepend(newMediaModal);
      }

      // updateURL() {
      //   if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      //   window.history.replaceState(
      //     {},
      //     "",
      //     `${this.dataset.url}?variant=${this.currentVariant.id}`
      //   );
      // }
       updateURL() {
  if (!this.currentVariant || this.dataset.updateUrl === "false") return;
  const sale_collection_check = this.dataset.sale;
  const sale_collection_URL = this.dataset.collection;
  let newUrl;
  if (sale_collection_check) {
    newUrl = `${sale_collection_URL}?variant=${this.currentVariant.id}`;
  } else {
    newUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
  }
  window.history.replaceState({}, "", newUrl);
}

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => {
              const optionKey = `option${index}`;

              if (previousOptionSelected) {
                return (
                  variant.available &&
                  variant[optionKey] === previousOptionSelected
                );
              } else {
                return variant.available;
              }
            })
            .map((variantOption) => {
              return variantOption[`option${index + 1}`];
            });

          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
          } else {
            input.classList.add("disabled");
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability"
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      // renderProductInfo() {
      //   const requestedVariantId = this.currentVariant?.id;
      //   const sectionId = this.dataset.originalSection
      //     ? this.dataset.originalSection
      //     : this.dataset.section;

      //   fetch(
      //     `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection
      //       ? this.dataset.originalSection
      //       : this.dataset.section
      //     }`,
      //   )
      //     .then((response) => response.text())
      //     .then((responseText) => {
      //       // prevent unnecessary ui changes from abandoned selections
      //       if (this.currentVariant?.id !== requestedVariantId) return;

      //       const html = new DOMParser().parseFromString(
      //         responseText,
      //         "text/html",
      //       );
      //       const destination = document.getElementById(
      //         `price-${this.dataset.section}`,
      //       );
      //       const source = html.getElementById(
      //         `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
      //       );
      //       const skuSource = html.getElementById(
      //         `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
      //       );
      //       const skuDestination = document.getElementById(
      //         `Sku-${this.dataset.section}`,
      //       );
      //       const inventorySource = html.getElementById(
      //         `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
      //       );
      //       const inventoryDestination = document.getElementById(
      //         `Inventory-${this.dataset.section}`,
      //       );

      //       // Product Alteration update
      //       const sourceProxyButton = html.querySelector(".proxy-atc-button.alteration-atc");
      //       const destinationProxyButton = document.querySelector(".proxy-atc-button.alteration-atc");

      //       if (sourceProxyButton && destinationProxyButton) {
      //         destinationProxyButton.dataset.mainProductId = sourceProxyButton.dataset.mainProductId;
      //         destinationProxyButton.dataset.mainProductTitle = sourceProxyButton.dataset.mainProductTitle;
      //         destinationProxyButton.dataset.alterationProductId = sourceProxyButton.dataset.alterationProductId;
      //       }

      //       // Product Customization update
      //       const sourceProxyButtonCustomization = html.querySelector(".proxy-atc-button.customization-atc");
      //       const destinationProxyButtonCustomization = document.querySelector(".proxy-atc-button.customization-atc");

      //       if (sourceProxyButtonCustomization && destinationProxyButtonCustomization) {
      //         destinationProxyButtonCustomization.dataset.mainProductId = sourceProxyButtonCustomization.dataset.mainProductId;
      //         destinationProxyButtonCustomization.dataset.mainProductTitle = sourceProxyButtonCustomization.dataset.mainProductTitle;
      //         destinationProxyButtonCustomization.dataset.alterationProductId = sourceProxyButtonCustomization.dataset.alterationProductId;
      //       }

      //       if (source && destination) destination.innerHTML = source.innerHTML;
      //       if (inventorySource && inventoryDestination)
      //         inventoryDestination.innerHTML = inventorySource.innerHTML;
      //       if (skuSource && skuDestination) {
      //         skuDestination.innerHTML = skuSource.innerHTML;
      //         skuDestination.classList.toggle(
      //           "visibility-hidden",
      //           skuSource.classList.contains("visibility-hidden"),
      //         );
      //       }

      //       const price = document.getElementById(
      //         `price-${this.dataset.section}`,
      //       );

      //       if (price) price.classList.remove("visibility-hidden");

      //       if (inventoryDestination)
      //         inventoryDestination.classList.toggle(
      //           "visibility-hidden",
      //           inventorySource.innerText === "",
      //         );

      //       const addButtonUpdated = html.getElementById(
      //         `ProductSubmitButton-${sectionId}`,
      //       );

      //       const isPreselectVariantEnabled = addButtonUpdated.dataset.enabledPreselect;
      //       let isDisabledButton;
      //       if (isPreselectVariantEnabled == true) {
      //         isDisabledButton = addButtonUpdated.hasAttribute("disabled");
      //       } else {
      //         if (addButtonUpdated.dataset.available == "false") {
      //           isDisabledButton = true;
      //         } else {
      //           isDisabledButton = false;
      //         }
      //       }
      //       this.toggleAddButton(addButtonUpdated
      //         ? isDisabledButton
      //         : true,
      //         window.variantStrings.soldOut
      //       );

      //       publish(PUB_SUB_EVENTS.variantChange, {
      //         data: {
      //           sectionId: sectionId,
      //           html,
      //           variant: this.currentVariant
      //         },
      //       });
      //     });
      // }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        const productAlterationButtons = document.querySelectorAll(
          ".product-alteration-button"
        );
        const shipRocketButton = document.querySelector(
          ".shiprocket-headless.actual-button[data-type=product]"
        );
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
          if (document.querySelector(
            ".shopify-payment-button"
          )) {
                document.querySelector(
            ".shopify-payment-button"
          ).style.pointerEvents = "none";
          }
      
          if (productAlterationButtons) {
            productAlterationButtons.forEach((button) =>
              button.setAttribute("disabled", "disabled")
            );
          }

          if (shipRocketButton) {
            shipRocketButton.style.pointerEvents = "none";
            shipRocketButton.style.opacity = "0.5";
          }
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
            if (document.querySelector(
            ".shopify-payment-button"
          )) {
                   document.querySelector(
            ".shopify-payment-button"
          ).style.pointerEvents = "all";
          }
       
          if (productAlterationButtons) {
            productAlterationButtons.forEach((button) =>
              button.removeAttribute("disabled")
            );
          }

          if (shipRocketButton) {
            shipRocketButton.style.pointerEvents = "all";
            shipRocketButton.style.opacity = "1";
          }
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }
    }
  );
}
// customElements.define('variant-options', VariantOptions);

/* CT scoped inventory rule (2026-08-26): on flagged products, show the
   inventory line only when the displayed size has fewer units than the
   block's low-stock threshold. Applies to every product that renders
   the inventory block; the B2B template keeps the block disabled. */
(() => {
  window.ctHideUnlessLow = true;

  if (!window.ctHideUnlessLow) return;
  const apply = () => {
    const el = document.querySelector(".product__inventory");
    if (!el) return;
    el.dataset.hideUnlessLow = "true";
    /* with no size chosen the server-rendered figure is just the
       default (smallest) size's stock - say nothing until a size is
       actually picked (via URL variant or a checked input). */
    const picked =
      window.location.href.includes("?variant") ||
      document.querySelector(".wt-product__option input:checked");
    const qty = parseInt((el.textContent.match(/\d+/) || [])[0], 10);
    const threshold = Number(el.dataset.inventoryThreshold);
    /* bare "In stock" (no digits) means qty is unknown or zero -
       fail closed and hide rather than show a stale claim. */
    if (!picked || Number.isNaN(qty) || qty >= threshold || qty <= 0)
      el.classList.add("hidden");
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
})();

/* CT heavyweight size-up note (2026-08-26): new copy, and shown only
   while a small size (S/M) is selected - sizing-up advice is noise
   for anyone else. */
(() => {
  const notes = document.querySelectorAll("p.size-up-text");
  if (!notes.length) return;
  /* Polos carry "Heavyweight" in their titles and catch this note too -
     the size-up advice applies to the heavyweight tee fit only. */
  if (document.title.toLowerCase().includes("polo")) {
    notes.forEach((n) => n.remove());
    return;
  }
  notes.forEach((n) => (n.textContent = "Size up for regular fit"));
  const SMALL = ["S", "M"];
  const toggle = () => {
    const picked = notes[0]
      .closest(".wt-product__option")
      ?.querySelector("input:checked")
      ?.value?.trim()
      .toUpperCase();
    const show = SMALL.includes(picked);
    notes.forEach((n) => n.classList.toggle("hidden", !show));
  };
  document.addEventListener("variantChangeEnd", toggle);
  toggle();
})();

/* CT exchange reassurance (2026-08-28): size anxiety is the top apparel
   conversion blocker - restate the exchange promise at the size picker.
   What it says comes from snippets/product-head.liquid (2026-10-22): a
   product tagged no-return-products, the tag Return Prime obeys, reads
   "14-day Exchanges", the rest "14-day Returns and Exchanges". No rule on
   the page = no line (SlowFlow, gift cards, client B2B merch). */
(() => {
  const sizeOption = document
    .querySelector(".wt-product__option fieldset")
    ?.closest(".wt-product__option");
  if (!sizeOption || sizeOption.querySelector(".ct-exchange-note")) return;
  const rule = (sizeOption.closest(".shopify-section") || document).querySelector(
    "template.ct-return-rule"
  );
  if (!rule || !rule.dataset.copy) return;
  const note = document.createElement("p");
  note.className = "ct-exchange-note";
  note.textContent = rule.dataset.copy;
  const anchor = sizeOption.querySelector("p.size-up-text");
  if (anchor) anchor.insertAdjacentElement("beforebegin", note);
  else sizeOption.appendChild(note);
})();

/* CT sticky-bar size state (2026-08-28): once a size is picked, the
   sub-label under the sticky Add to cart / Buy now buttons shows the
   chosen size instead of the "Select Size" prompt. */
(() => {
  const subs = document.querySelectorAll(".wt-product__sticky-buy .ct-sub");
  if (!subs.length) return;
  const toggle = () => {
    const picked = document
      .querySelector(".wt-product__option input:checked")
      ?.value?.trim();
    subs.forEach(
      (s) => (s.textContent = picked ? "- " + picked : "Select Size")
    );
  };
  document.addEventListener("variantChangeEnd", toggle);
  toggle();
})();
